<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      :destroyOnClose="true"
      :width="800"
    >
      <a-form-model
        ref="InstanceManagerForm"
        :model="instance"
        :rules="rules"
        layout="vertical"
      >
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="Business" prop="businessId">
              <a-select
                placeholder="Business"
                v-model="instance.businessId"
                style="width: 100%"
              >
                <a-select-option
                  v-for="business in businesses"
                  :key="business.id"
                  :value="business.id"
                >
                  {{ business.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Name" prop="name">
              <a-input placeholder="Name" v-model="instance.name" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="Url" prop="url">
              <a-input placeholder="Url" v-model="instance.url" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Limit" prop="limit">
              <a-input
                type="number"
                :min=0
                placeholder="Limit"
                v-model="instance.limit"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <template #footer>
        <a-button type="primary" @click="save" :loading="isSaving"
          >Save</a-button
        >
        <a-button @click="cancel">Cancel</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import ModalMixin from "../Common/Mixins/modalMixin";
import { instanceManagerMutations } from "../../Store/store";
import { helper } from '../../Utilities/helper';

export default {
  props: {
    instance: {
      type: Object,
      default: () => ({}),
    },
    businesses: { type: Array, default: () => [] },
  },
  mixins: [ModalMixin],
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please input a Name!",
            trigger: "blur",
          },
        ],
        businessId: [
          { required: true, message: "Business is required!", trigger: "blur" },
        ],
        url: [
          {
            required: true,
            message: "Please input a url!",
            trigger: "blur",
            
          },
          { validator: helper.urlValidator, trigger: 'blur' }
        ],
        limit: [
          {
            required: true,
            message: "Please input a Limit!",
            trigger: "blur",
          },
          { validator: helper.inputNumberValidator, trigger: 'blur' }
        ],
      },
      isSaving: false,
    };
  },
  computed: {
    addInstanceManagerSuccess() {
      return `Instance Manager ${
        this.mode == this.modes.edit ? "updated" : "added"
      } successfully!`;
    },
  },
  methods: {
    save() {
      this.$refs.InstanceManagerForm.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;
          try {
            if (this.mode == this.modes.edit) {
              await instanceManagerMutations.updateInstanceManager(
                this.instance
              );
            } else {
              await instanceManagerMutations.addInstanceManager(this.instance);
            }
            this.$message.success(this.addInstanceManagerSuccess);
            this.visible = false;
          } catch (error) {
            this.$message.error(
              error.response?.data?.errors[0]?.message ?? error.message
            );
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
  },
};
</script>